// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcsxWGEdGlkvRbICovU2bJw4NE7ZdeUTw",
  authDomain: "xdc-marketing-and-branding.firebaseapp.com",
  databaseURL: "https://xdc-marketing-and-branding-default-rtdb.firebaseio.com",
  projectId: "xdc-marketing-and-branding",
  storageBucket: "xdc-marketing-and-branding.appspot.com",
  messagingSenderId: "473515724182",
  appId: "1:473515724182:web:480aa5d1fdc2a5794b21b7",
  measurementId: "G-T0R1P59VNC"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore();
export const database = getDatabase(app);